import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';

export class IOSFlowContainer extends React.Component {
  constructor (props) {
    super(props);
    this.flow = new URLSearchParams(window.location.search).get('flow');

    this.showBookingReceiptModal = this.showBookingReceiptModal.bind(this);
    this.showCustomOfferModal = this.showCustomOfferModal.bind(this);
    this.showUpdateRequestModal = this.showUpdateRequestModal.bind(this);
    this.showReviewBookingRequestModal = this.showReviewBookingRequestModal.bind(this);
  }

  componentDidMount () {
    const iosWebView = get(this.props, 'iosWebView');
    if (!this.flow || !iosWebView) {
      return;
    }
    // Open appropriate flow modal depends on `flow` url query parameter
    if ('booking-receipt' === this.flow) {
      this.showBookingReceiptModal();
    } else if ('custom-offer' === this.flow) {
      this.showCustomOfferModal();
    } else if ('update-request' === this.flow) {
      this.showUpdateRequestModal();
    } else if ('review-request' === this.flow) {
      this.showReviewBookingRequestModal();
    }
    this.flow = null;
    window.history.replaceState({}, document.title, '/bookings/ios.html');
  }

  showBookingReceiptModal () {
    const objState = get(this.props, 'details.obj_state');
    const viewAs = get(this.props, 'details.viewAs');
    const renderReviewOfferDetails = get(this.props, 'renderReviewOfferDetails');
    if (renderReviewOfferDetails) {
      renderReviewOfferDetails(objState, 'HOST' === viewAs);
    }
  }

  showCustomOfferModal () {
    const showCustomOfferModal = get(this.props, 'status.showCustomOfferModal', null);
    if (showCustomOfferModal) {
      showCustomOfferModal();
    }
  }

  showUpdateRequestModal () {
    const showRequestUpdateModal = get(this.props, 'status.showRequestUpdateModal', null);
    if (showRequestUpdateModal) {
      showRequestUpdateModal();
    }
  }

  showReviewBookingRequestModal () {
    const showModal = get(this.props, 'status.showReviewBookingRequestModal', null);
    if (showModal) {
      showModal();
    }
  }

  render () {
    const { children, status } = this.props;
    return React.cloneElement(children, { status });
  }
}

IOSFlowContainer.propTypes = {
  iosWebView: PropTypes.bool,
  status: PropTypes.object,
  renderReviewOfferDetails: PropTypes.func,
  children: PropTypes.element.isRequired
};
